<!--
    Versione 1.0 del 20240123
    
    Storia:
      * primo versionamento

-->
<template>
  <div class="divContainer">
    <div @click="ToggleContent">{{ TestoSelezionato() }}</div>
    <div class="divContent" v-if="mostraContent">
        <input type="text" placeholder="Cerca..." v-model="testoRicerca" /><br />
        <ul>
            <li v-for="d, i in QueryDati" :key="i" @click="Seleziona(i)" :class="IsSelected(d)">{{ d[1] }}</li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
    name: "SelectCercabile",
    props: {
        dati: [],
        
        multiselect: {
            type: Boolean,
            default: false
        },

        SetSelected: [],

    },
    data: function () {
        return {
            selected: [["","Seleziona..."]],

            mostraContent: false,
            testoSelezionato: 'Seleziona...',

            testoRicerca: '',
            
        }
    },
    methods: {
        //Cerca il primo valore 
        Cerca(arr, value) {
            let res = -1;
            for(let i = 0; i<arr.length; i++) {
                if(arr[i][0] == value) {
                    res = i;
                }
            } 

            //console.log(res)

            return res;
        },
        Seleziona (i) {
            if(!this.multiselect) {
                //single select
                this.selected.splice(0);
                //this.selected.push(this.dati[i]);
                this.selected.push(this.QueryDati[i]);
                this.mostraContent = false;
                this.$emit('selezionato', this.selected);
                
            } else {
                //multi select
                if(this.selected.length >= 1 && this.selected[0][0] == '') this.selected.splice(0, 1);
                if(this.Cerca(this.selected, this.dati[i][0]) < 0) {
                    //non trovato
                    this.selected.push(this.dati[i]);
                } else {
                    //trovato
                    let ndx = this.Cerca(this.selected, this.dati[i][0]);
                    if(ndx >= 0) {
                        this.selected.splice(ndx, 1);
                    }
                }
                
            }

        },

        ToggleContent() {
            this.mostraContent = !this.mostraContent;
            if(this.multiselect) this.$emit('Selected', this.selected);
        },

        IsSelected(e) {
            let res = "";
            let ndx = this.Cerca(this.selected, e[0])
            if(ndx >= 0) {
                res = "selected";
            }
            return res;
        },


        TestoSelezionato () {
            let res = this.testoSelezionato;
            if(this.selected.length>0) {
                res = '';
                for(let i = 0; i<this.selected.length; i++) {
                    // if(!this.selected[i][1] == undefined) res += this.selected[i][1] + ', ';
                    // else {
                    //     //Se il testo della selòected non è passato, lo cerca nella sorgente
                    //     res = this.dati[this.Cerca(this.dati, this.selected[i][0])][1];
                    // }
                    //alert(this.Cerca(this.dati, this.selected[i][0])[1])
                    //res = this.Cerca(this.dati, this.selected[i][0]);
                    //res += this.selected[i][1] + ', ';
                    let iCerca = this.Cerca(this.dati, this.selected[i][0]);
                    if(iCerca>= 0) {
                        res += this.dati[iCerca][1] + ', ';
                    }
                    else {res += this.selected[i][1] + ', ';}

                }
            }
            return res;
        },

    },
    computed: {
        
        

        QueryDati() {
            if(this.testoRicerca == '') {
                //senza filtri
                return this.dati;
            } else {
                //con filtro
                let res = [];
                for(let i = 0; i<this.dati.length; i++) {
                    if((this.dati[i][1]).toLowerCase().indexOf(this.testoRicerca.toLowerCase()) >= 0) {
                        res.push(this.dati[i]);
                    }
                }
                return res;
            }
            
        }

    },
    watch: {
        SetSelected(nv,ov) {
            //alert(nv)
            this.selected = nv
        }
    }
}
</script>

<style scoped>
 div.divContainer {
    width: 100%;
    line-height: 30px;
    border:solid 1px #999;
    padding-top:2px;
    padding-bottom:2px;
    padding-right:5px;
    padding-left:5px;
    

    border-radius: 5px;

 }

 div.divContent {
    position:absolute;
    border:solid 1px #999;
    background-color: #fff;

    max-height: 250px;
    overflow-y: scroll;

    margin-top:5px;

    padding-top:2px;
    padding-bottom:2px;
    padding-right:10px;
    padding-left:10px;


    z-index:1000;

 }

 input {
    width:100%;
    border-radius: 5px;
    border:solid 1px #000;
    margin-bottom: 3px;
 }

 ul {
  list-style-type: none; /* Remove bullets */
  padding: 0; /* Remove padding */
  margin: 0; /* Remove margins */
}

li {
    padding: 2px;
}

li:hover {
    background-color: #aaa;
}

li.selected {
    background-color: #ddd;
}
</style>